<template>
  <v-container class="mt-8">
    <v-row justify="center" align="center" dense>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="dialogUsuario = true"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-account-plus</v-icon>
            Cadastrar Usuário
          </v-card-title>
          <v-card-text>
            Cadastre um novo usuário do sistema.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <CadastroUsuarioDialog v-model="dialogUsuario" />
  </v-container>
</template>

<script>
import CadastroUsuarioDialog from "@/components/CadastroUsuarioDialog.vue";

export default {
  components: {
    CadastroUsuarioDialog,
  },
  data: () => ({
    dialogUsuario: false,
  }),
};
</script>

<style scoped>
.custom-card {
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  cursor: pointer;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.custom-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  transform: translateY(-4px) scale(1.025);
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  align-items: center;
  display: flex;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
  margin-top: 4px;
}
.text-center {
  text-align: center;
}
</style>